import styled from "@emotion/styled/macro"
import { theme, device } from "../Theme"

const CouponCardContainer = styled.div`
  position: relative;
  margin-top: 40px;

  @media ${device.md} {
    margin-top: 69px;
  }
`

const CouponImage = styled.div`
  position: absolute;
  left: 50%;
  top: -40px;
  transform: translate(-50%, 0);
  width: 109px;
  height: 80px;
  z-index: 1;

  & > * {
    width: 100%;
    height: 100%;
  }

  @media ${device.md} {
    width: 187px;
    height: 138px;
    top: -69px;
  }
`

const Top = styled.div`
  background: transparent;
  padding: 0 30px 0;
  height: 162px;
  position: relative;

  @media ${device.md} {
    height: 280px;
  }
`

const Content = styled.div`
  text-align: center;
  display: grid;
  grid-template-rows: auto 1fr;
  height: 100%;

  & > * {
    z-index: 1;
  }

  & > p {
    font-family: ${theme.fonts.main};
    font-size: 13px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.1px;
    text-align: center;
    color: ${theme.colors.body};
    padding-top: 0;
    align-self: center;

    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    /* not needed even though some documentation says it is
    text-overflow: ellipsis; */

    @media ${device.md} {
      font-size: 20px;
      line-height: 31px;
      letter-spacing: 0.2px;
    }
  }

  & > p:first-of-type {
    font-family: ${theme.fonts.altFont};
    font-size: 14px;
    font-weight: 900;
    line-height: 18px;
    letter-spacing: 0px;
    text-align: center;
    color: #010101;
    padding-top: 53px;

    & > strong {
      font-weight: 900;
    }

    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    /* not needed even though some documentation says it is
    text-overflow: ellipsis; */

    @media ${device.md} {
      font-size: 26px;
      font-weight: 900;
      line-height: 30px;
      padding-top: 100px;
    }
  }
`

const Bottom = styled.div`
  padding: 0 40px;
  height: 162px;
  display: flex;
  align-items: center;
  flex-direction: column;
  background: transparent;
  position: relative;

  & > * {
    z-index: 1;
  }

  @media ${device.md} {
    height: 280px;
    padding: 0 67px;
  }
`

const Discount = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  border-radius: 25px;
  border: 2px dashed #0a0a0a;
  padding: 0 27px;
  margin: 20px 0 14px;
  background: ${theme.colors.light};

  @media ${device.md} {
    height: 86px;
    border-radius: 43px;
    padding: 0 46px;
    margin: 38px 0 14px;
  }
`

const DiscountValue = styled.span`
  font-family: ${theme.fonts.main};
  font-size: 45px;
  font-weight: ${props => props.fontWeight};
  line-height: 31px;
  letter-spacing: -0.9px;
  text-align: center;
  margin-bottom: 0;
  color: #0b0b0b;
  font-style: ${props => (props.italic ? "italic" : "normal")};

  @media ${device.md} {
    font-size: 79px;
    letter-spacing: -1.6px;
  }
`

const DiscountOff = styled.span`
  font-family: ${theme.fonts.main};
  font-size: 16px;
  font-weight: 700;
  line-height: 17px;
  letter-spacing: 0.32px;
  text-align: center;
  margin-bottom: 0;
  color: #0b0b0b;
  transform: rotate(-90deg);

  @media ${device.md} {
    font-size: 29px;
    font-weight: 700;
    line-height: 31px;
    letter-spacing: 0.58px;
  }
`

const CouponCodeText = styled.h1`
  font-family: ${theme.fonts.main};
  font-size: 13px;
  font-weight: 700;
  line-height: 17px;
  letter-spacing: -0.26px;
  text-align: center;
  margin-bottom: 6px;
  color: #0b0b0b;

  @media ${device.md} {
    font-size: 23px;
    line-height: 31px;
    letter-spacing: -0.46px;
    margin-bottom: 1rem;
  }
`

const CouponCode = styled.div`
  width: fit-content;
  height: 28px;
  display: flex;
  align-items: center;
  padding: 0 9px;
  background: #ce1213;

  font-family: ${theme.fonts.main};
  font-size: 25px;
  font-weight: 800;
  letter-spacing: -0.5px;
  text-align: center;
  color: ${theme.colors.light};

  @media ${device.md} {
    height: 43px;
    padding: 0 16px;
    font-size: 43px;
    letter-spacing: -0.86px;
  }
`

const TopBackground = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 0;

  & > * {
    width: 100%;
    height: 100%;
  }
`

const BottomBackground = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 0;

  & > * {
    width: 100%;
    height: 100%;
  }
`

export {
  CouponCardContainer,
  CouponImage,
  Top,
  Content,
  Bottom,
  Discount,
  DiscountValue,
  DiscountOff,
  CouponCodeText,
  CouponCode,
  TopBackground,
  BottomBackground,
}
